import { useAppDispatch } from "../../api/core/useAppDispatch";
import { useCallback, useEffect, useState } from "react";
import { fetchRebuildProgress } from "../../api/features/book-rebuild/actions";

const POLL_INTERVAL_MS = 1000;

export default function useRebuildProgress() {
  const dispatch = useAppDispatch();
  const [percentComplete, setPercentComplete] = useState(0);

  const fetchStatus = useCallback(() => {
    dispatch(fetchRebuildProgress()).then((response) => {
      if (response.ok) {
        const result = response.data[0];
        if (result) {
          setPercentComplete(result.percentage);
          if (result.percentage !== 100) {
            window.setTimeout(fetchStatus, POLL_INTERVAL_MS);
          }
        } else {
          setPercentComplete(100);
        }
      } else {
        window.setTimeout(fetchStatus, POLL_INTERVAL_MS);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return percentComplete;
}
